// Core imports
import * as React from 'react';
import {
  goToHome,
  goToVerify,
  goToDashboard,
  goToSamsungOrderInvoicePortal,
  goToSiteTour,
  goToAccount,
  goToOrdersView,
  goToAccountUnsubscribe
} from 'src/utils/navigation';

// Components imports
import SignIn from 'src/components/SignIn';
import UserUpdateInfo from 'src/components/UserUpdateInfo';
import AccountSwitch from 'src/components/AccountSwitch';
// Models imports Style and misc imports
import './SignInView.scss';
import env from 'src/shared/env';
import { exit } from 'process';

interface ISignInViewProps {
  login(userId: string, password: string): any;
  shouldSelectAccount: boolean;
  pending: boolean;
  signinFailed: boolean;
  signinError: string;
  t: any;
  isLoggedIn: boolean;
  shouldVerify: boolean;
  shouldUpdateInfo: boolean;
  specialUser: string;
  userData: any;
  isSamsungUser: boolean;
}

class SignInView extends React.Component<ISignInViewProps, any> {
  private enableVerify = parseInt(env.REACT_APP_ENABLE_VERIFY_ACCOUNT, 10);

  private redirectToHome = () => {
    if (
      this.enableVerify &&
      this.props.isLoggedIn &&
      this.props.shouldVerify &&
      !this.props.shouldUpdateInfo
    ) {
      goToVerify();
      return;
    }
    if (
      this.props.isLoggedIn &&
      this.props.isSamsungUser &&
      !this.props.shouldSelectAccount &&
      !this.props.shouldUpdateInfo
    ) {
      const footerhidden = document.getElementsByClassName('mainfooter')[0]
        ? document
            .getElementsByClassName('mainfooter')[0]
            .setAttribute('style', 'display:none')
        : '';
      goToSamsungOrderInvoicePortal();
      return;
    }
   
    // for unsubscribe registered user or redirect to account page for preferences setting
    if (
      this.props.isLoggedIn &&
      !this.props.shouldSelectAccount &&
      (localStorage.getItem('rpage') === 'registered' || localStorage.getItem('manageaccount') === 'account')
    ) {
      const lang = window.location.pathname.split('/').filter(Boolean)[1];    
      goToAccountUnsubscribe(lang);
      return;
    }

    if (
      this.props.isLoggedIn &&
      !this.props.shouldSelectAccount &&
      (localStorage.getItem('orderNumberView'))
    ) {      
      goToOrdersView(localStorage.getItem('orderNumberView'));
      return;
    }


    if (
      this.props.isLoggedIn &&
      this.props.specialUser &&
      !this.props.shouldSelectAccount &&
      !this.props.shouldUpdateInfo
    ) {
      if(localStorage.getItem('redirectUrl')) {
        goToSiteTour();
      return;
      } else {
        goToDashboard();
      return;
      }
    }
    if (
      this.props.isLoggedIn &&
      !this.props.shouldSelectAccount &&
      !this.props.shouldUpdateInfo
    ) {
      if(localStorage.getItem('redirectUrl')) {
        goToSiteTour();
      } else { 
        goToHome();
      }
    }
  };

  public componentDidMount() {
    if (window.location.href.includes('regispage')) {
      localStorage.setItem('rpage', 'registered');
    } else {
      localStorage.removeItem('rpage');
    }
    if (window.location.href.includes('manage')) {
      localStorage.setItem('manageaccount', 'account');
    } else {
      localStorage.removeItem('manageaccount');
    }
    if (window.location.href.includes('orders')) {
      const hash = window.location.hash;
      let orderNumber ='';
      // Get the query string from the hash (split by '?')
      const queryString = hash.split('?')[1]; // "orders=1061392"
      if (queryString) {
      const params = new URLSearchParams(queryString);
      orderNumber = params.get('orders');
    }    
    localStorage.setItem('orderNumberView', orderNumber);

    } else {
      localStorage.removeItem('orderNumberView');
    }
    this.redirectToHome();
  }

  public componentDidUpdate(prevProps: ISignInViewProps) {
    if (
      this.props.isLoggedIn !== prevProps.isLoggedIn ||
      this.props.shouldUpdateInfo !== prevProps.shouldUpdateInfo
    ) {
      this.redirectToHome();
    }
  }

  public render() {
    if (this.props.shouldSelectAccount === true) {
      return (
        <section id="account-view">
          <AccountSwitch />
        </section>
      );
    } else if (this.props.shouldUpdateInfo && this.props.shouldVerify) {
      return (
        <section id="account-view">
          <UserUpdateInfo />
        </section>
      );
    } else {
      return (
        <section id="account-view">
          <SignIn
            login={this.props.login}
            pending={this.props.pending}
            signinFailed={this.props.signinFailed}
            signinError={this.props.signinError}
            isLoggedIn={this.props.isLoggedIn}
            shouldSelectAccount={this.props.shouldSelectAccount}
            shouldVerify={this.props.shouldVerify}
            shouldUpdateInfo={this.props.shouldUpdateInfo}
          />
        </section>
      );
    }
  }
}

export default SignInView;
